import React, { Component } from 'react';
import $ from "jquery";

export default class OptSearch3 extends Component {
    constructor(props) {
        super(props);
        let data = { ...props.data };
        this.state = {
            dynamicId: ""
        }
    }

    submitOptForm(needReload = false) {
        let match = "{";
        let inputText = $("#search-text").val();
        const OptSearchUrl = window.location.pathname;

        $("p.selected").text(inputText);
        $("p.selected").attr("value", inputText);

        let params = {};

        $(".search-row").each(function () {
            let title = $(this).children(".search-form__td-title").attr("value");
            let value = $(this).find("li.selected").attr("value");

            if (title && value) {
                params[title] = value;
                match += `"${title}":"${value}", `;
                sessionStorage.setItem(title, value);
            }
        });

        match = match.slice(0, -2) + "}";

        sessionStorage.setItem("OptSearchUrl", OptSearchUrl);
        // sessionStorage.setItem("OptSearch", match);

        let queryString = Object.keys(params)
            .map(key => `${key}=${encodeURIComponent(params[key])}`)
            .join('&');

        let newUrl = `${OptSearchUrl}?${queryString}`;
        window.history.pushState(null, '', newUrl);

        if (needReload)
            window.location.reload(false);
    }

    componentDidMount() {
        const currentPath = window.location.pathname;
        const urlParams = new URLSearchParams(window.location.search);

        sessionStorage.setItem('OptSearchUrl', currentPath);

        const composition = String(urlParams.get('id_composition'));
        const institution = String(urlParams.get('id_institution'));
        const country = String(urlParams.get('id_country'));
        const year = String(urlParams.get('id_year'));

        let setReload = true
        let optSearchObj = {};


        if (composition) {
            sessionStorage.setItem('id_composition', composition);
            optSearchObj["id_composition"] = composition;
        }
        if (institution) {
            sessionStorage.setItem('id_institution', institution);
            optSearchObj["id_institution"] = institution;
        }
        if (country) {
            sessionStorage.setItem('id_country', country);
            optSearchObj["id_country"] = country;
        }
        if (year) {
            sessionStorage.setItem('id_year', year);
            optSearchObj["id_year"] = year;
        }

        sessionStorage.setItem('OptSearch', JSON.stringify(optSearchObj));

        this.loadFiltersFromSessionStorage();

        //console.log(composition === sessionStorage.getItem('id_composition') && institution === sessionStorage.getItem('id_institution') && country === sessionStorage.getItem('id_country') && year === sessionStorage.getItem('id_year'));
        if (!sessionStorage.getItem('submitFormCalled') && setReload) {
            this.submitOptForm();
            sessionStorage.setItem('submitFormCalled', 'true');


        } else if (composition === sessionStorage.getItem('id_composition') && institution === sessionStorage.getItem('id_institution') && country === sessionStorage.getItem('id_country') && year === sessionStorage.getItem('id_year')) {
            setReload = false
            sessionStorage.removeItem('submitFormCalled')
            //console.log('takie same');
            this.submitOptForm();
        }

        //console.log(composition == sessionStorage.getItem('id_composition'), institution == sessionStorage.getItem('id_institution'), country == sessionStorage.getItem('id_country'), year == sessionStorage.getItem('id_year'));
        //console.log(sessionStorage.getItem('id_year'), sessionStorage.getItem('id_country'), sessionStorage.getItem('id_institution'), sessionStorage.getItem('id_composition'));
        //console.log(year, country, institution, composition);
    }

    loadFiltersFromSessionStorage() {
        let composition = sessionStorage.getItem('id_composition');
        let institution = sessionStorage.getItem('id_institution');
        let country = sessionStorage.getItem('id_country');
        let year = sessionStorage.getItem('id_year');

        const urlParams = new URLSearchParams(window.location.search);
        const compositionUrl = urlParams.get('id_composition');
        const institutionUrl = urlParams.get('id_institution');
        const countryUrl = urlParams.get('id_country');
        const yearUrl = urlParams.get('id_year');

        if (composition != null && composition === compositionUrl) {
            $("#composition li").removeClass("selected");
            $("#composition li").each(function () {
                if ($(this).attr("value") == composition) {
                    $(this).addClass("selected");
                }
            })
        }
        if (institution != null && institution === institutionUrl) {
            $("#institution li").removeClass("selected");
            $("#institution li").each(function () {
                if ($(this).attr("value") == institution) {
                    $(this).addClass("selected");
                }
            })
        }
        if (country != null && country === countryUrl) {
            $("#country li").removeClass("selected");
            $("#country li").each(function () {
                if ($(this).attr("value") == country) {
                    $(this).addClass("selected");
                }
            })
        }
        if (year != null && year === yearUrl) {
            $("#year li").removeClass("selected");
            $("#year li").each(function () {
                if ($(this).attr("value") == year) {
                    $(this).addClass("selected");
                }
            })
        }
    }

    render() {

        document.addEventListener("keypress", function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                document.getElementById("search-engine-submit").click();
            }
        });

        $(function () {
            $(".select-container ul").unbind().click(function () {
                $(this).toggleClass("opened");
            });

            $("#optional-search-form ul li").click(function () {
                var match = "{";
                var inputText = $("#search-text").val();
                $("p.selected").text(inputText);
                $("p.selected").attr("value", inputText)
                if ($(this).hasClass("selected")) {
                }
                else {
                    $(this).addClass("selected").siblings().removeClass("selected");

                    const parentId = $(this).parent("ul").attr('id');
                    const itemValue = $(this).attr("value");
                    sessionStorage.setItem(`id_${parentId}`, itemValue)

                    $(".search-row").each(function () {
                        var title = $(this).children(".search-form__td-title").attr("value");
                        var value = $(this).find(".selected").attr("value");
                        match += '"' + title + '":';
                        match += '"' + value + '", ';
                    });

                }
                // console.log(match);
                match = match.slice(0, -2);
                match += "}";
                // console.log(match);
                sessionStorage.setItem("OptSearch3", match);
            });

            $('#search-text').on('input', function (e) {
                var inputText = $("#search-text").val();
                $("p.selected").text(inputText);
            });

        });

        $(document).mouseup(function (e) {
            var container = $(".select-container ul.opened");
            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                container.removeClass("opened");
            }
        });

        // LABELS BASED ON LANGUAGE
        let search_label_1 = window.location.href.indexOf("/en/") > -1 ? "Clear" : "Wyczyść";
        let search_label_3 = window.location.href.indexOf("/en/") > -1 ? "Search" : "Szukaj";
        let search_label_4 = window.location.href.indexOf("/en/") > -1 ? "all" : "wszystkie";
        let search_label_5 = window.location.href.indexOf("/en/") > -1 ? "enter..." : "wpisz...";

        return (
            <div className="optional-search-container">

                <div id="optional-search-form" className="OptSearch3">
                    <table>
                        <tbody>
                            <tr>
                                <td className="search-row"><span className="search-form__td-title" value={this.props.filter_search[0].field_name}>{this.props.filter_search[0].name}</span>
                                    <div className="select-container">
                                        <ul id="composition">
                                            <li className="selected" value="">{search_label_4}</li>
                                            {this.props.filter_search[0].list.map(function (item, index) {
                                                var name = item.name;
                                                var id = item.id;
                                                return (
                                                    <li value={id} key={index} dangerouslySetInnerHTML={{ __html: name }}></li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </td>
                                <td className="search-row"><span className="search-form__td-title" value={this.props.filter_search[1].field_name}>{this.props.filter_search[1].name}</span>
                                    <div className="select-container">
                                        <ul id="institution">
                                            <li className="selected" value="">{search_label_4}</li>
                                            {this.props.filter_search[1].list.map(function (item, index) {
                                                var name = item.name;
                                                var id = item.id;
                                                return (
                                                    <li value={id} key={index} dangerouslySetInnerHTML={{ __html: name }}></li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="search-row"><span className="search-form__td-title" value={this.props.filter_search[2].field_name}>{this.props.filter_search[2].name}</span>
                                    <div className="select-container">
                                        <ul id="country">
                                            <li className="selected" value="">{search_label_4}</li>
                                            {this.props.filter_search[2].list.map(function (item, index) {
                                                var name = item.name;
                                                var id = item.id;
                                                return (
                                                    <li value={id} key={index} dangerouslySetInnerHTML={{ __html: name }}></li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </td>
                                <td className="search-row"><span className="search-form__td-title" value={this.props.filter_search[3].field_name}>{this.props.filter_search[3].name}</span>
                                    <div className="select-container">
                                        <ul id="year">
                                            <li className="selected" value="">{search_label_4}</li>
                                            {this.props.filter_search[3].list.map(function (item, index) {
                                                var name = item.name;
                                                var id = item.id;
                                                return (
                                                    <li value={id} key={index} dangerouslySetInnerHTML={{ __html: name }}></li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </td>
                            </tr>

                            {/* <tr>
							<td colSpan={2}><span className="search-form__td-title" value={this.props.filter_search[4].field_name}>{this.props.filter_search[4].name}</span>
								<div className="select-container">
									<input onChange={this.startType} id="opus" list="opusdata" type="text" placeholder={search_label_5} />
									<datalist id={this.state.dynamicId}>
										{this.props.filter_search[4].list.map(function (item, index) {
											return (
												<option key={index} value={item.id}>{item.name}</option>
											)
										})}
									</datalist>
								</div>
							</td>
						</tr> */}
                        </tbody>
                    </table>

                    <div className="search-engine-options">
                        <button onClick={this.clear}>{search_label_1}</button>
                        <button id="search-engine-submit" className="submit" onClick={() => { this.submitOptForm(true) }}>{search_label_3}</button>
                    </div>
                </div>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/OptSearch3/OptSearch3.js